import {api} from "@/shared/api";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";

interface RegisterPageConfig {
	requestLocale: string;
	loginUrl: string;
}

export class RegisterPage {
	private readonly config: RegisterPageConfig;
	private idEdited = false;

	constructor(config: RegisterPageConfig) {
		this.config = config;
		this.initialize();
	}

	private redirectToLogin() {
		window.location.href = this.config.loginUrl + "?username=" + ($("#email").val() as string);
	}

	private createConversionFrame() {
		const ifrm = document.createElement("IFRAME");
		ifrm.setAttribute("src", "conversion.html");
		ifrm.style.width = "1px";
		ifrm.style.height = "1px";
		document.body.appendChild(ifrm);
	}

	private submitRegistration(event: JQuery.Event) {
		event.preventDefault();
		api("register.json")
			.postForm("#registrationForm")
			.done(() => {
				this.createConversionFrame();
				BootstrapModal.info({
					title: "passwordForgotten.sent.header",
					message: "dialog.registration.success",
					escapeText: false,
					buttons: [{
						text: "confirmation.ok",
						action: () => this.redirectToLogin()
					}]
				});
			});
		return false;
	}

	private calculateId() {
		const company = $("#company").val() as string;
		const firstspace = company.indexOf(" ");
		const lowercaseId = company.substring(0, firstspace !== -1 ? firstspace : company.length).toLowerCase();
		let cleanedId = "";
		for (let i = 0; i < lowercaseId.length; i++) {
			if ("abcdefghijklmnopqrstuvwxyz0123456789".indexOf(lowercaseId.charAt(i)) !== -1) {
				cleanedId += lowercaseId.charAt(i);
			}
		}
		return cleanedId;
	}

	private updateIdentifier() {
		if (!this.idEdited) {
			$("#identifier").val(this.calculateId());
		}
	}

	private initialize() {
		$("#language").val(this.config.requestLocale);

		$("#identifier").keyup(event => {
			const currentValue = (event.currentTarget as HTMLInputElement).value;
			this.idEdited = this.calculateId() !== currentValue;
		});
		$("#email").change(event => {
			const target = event.currentTarget as HTMLInputElement;
			target.value = target.value.toLowerCase();
		});

		$("#company")
			.keyup(() => this.updateIdentifier())
			.change(() => this.updateIdentifier());

		$("#registrationForm").submit(event => this.submitRegistration(event));

		$("#firstname").focus();
	}
}
